/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Feat_StreetInputs */

const cs_pm_feat_street = /** @type {(inputs: Pm_Feat_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulice`)
};

const en_pm_feat_street = /** @type {(inputs: Pm_Feat_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street`)
};

/**
* | output |
* | --- |
* | "Street" |
*
* @param {Pm_Feat_StreetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_feat_street = /** @type {((inputs?: Pm_Feat_StreetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Feat_StreetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_feat_street(inputs)
	return cs_pm_feat_street(inputs)
});